import React from "react";
import loadable from "@loadable/component";

import {getEnrichData} from '../../actions/products'

export default {
	component: loadable(() => import("./EnrichEditProduct"), {
		fallback: <div>Loading...</div>
	}),
	clientData: (store,match,location,matchedRoute) => {
		const productBankId = match.params.productBankId?match.params.productBankId:'';
		return store.dispatch(getEnrichData({
			productBankId
		}));
	}
};
